export default __webpack_public_path__ + "static/media/05.4bd5dbb8.jpg";